import {
  Accordion,
  Button,
  Drawer,
  TextInput,
  Select as FBSelect,
} from 'flowbite-react';
import MultiRangeSlider, { ChangeResult } from 'multi-range-slider-react';
import { useEffect, useMemo, useState } from 'react';
import Loader from '../Common/Loader';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link } from 'react-router-dom';
import { FaFilter } from 'react-icons/fa6';
import SearchApi from '../../Api/SearchApi';
import { useAppSelector } from '../../Reducers/store';
import Select from 'react-select';
import { SearchRequest } from '../../Models/SearchRequest';
import { SearchResult } from '../../Models/SearchResult';
import { SelectOption } from '../../Models/SelectOption';
import { formatNumbers } from '../../Utils';
import InfiniteScroll from 'react-infinite-scroll-component';
//import PBLogo from '../../Assets/PriceBros-Logo.png';
import OrderApi from '../../Api/OrderApi';
import { OrderItem } from '../../Models/OrderItem';
import { Order } from '../../Models/Order';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import EmailModal from '../Forms/WarehouseAvailability';
import { Equipment } from '../../Models/Equipment';
import { Manufacturer } from '../../Models/Manufacturer';

export default function SearchPageParts() {
  const location = useLocation();
  const { userModel } = useAppSelector((state) => state.user);
  const { manufacturers, categories, subCategories, equipmentSearchData } =
    useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => setIsOpen(false);
  const [searchData, setSearchData] = useState<SearchResult[]>([]);
  const [formData, setFormData] = useState<SearchRequest>({
    searchText: localStorage.getItem('searchPartsTextState') ?? '',
    manufacturers: localStorage.getItem('manufacturersState')
      ? (
          JSON.parse(
            localStorage.getItem('manufacturersState')!
          ) as SelectOption[]
        ).map((a) => a.label!)
      : null,
    categories: localStorage.getItem('categoriesState')
      ? (
          JSON.parse(localStorage.getItem('categoriesState')!) as SelectOption[]
        ).map((a) => a.label!)
      : null,
    subCategories: localStorage.getItem('subCategoriesState')
      ? (
          JSON.parse(
            localStorage.getItem('subCategoriesState')!
          ) as SelectOption[]
        ).map((a) => a.label!)
      : null,
    minPrice: localStorage.getItem('minPriceState')
      ? Math.ceil(Number(localStorage.getItem('minPriceState')))
      : equipmentSearchData?.minPrice
      ? Math.ceil(equipmentSearchData?.minPrice)
      : 0,
    maxPrice: localStorage.getItem('maxPriceState')
      ? Math.ceil(Number(localStorage.getItem('maxPriceState')))
      : equipmentSearchData?.maxPrice
      ? Math.ceil(equipmentSearchData?.maxPrice)
      : 1000,
    limit: 30,
    skip: 0,
    reset: false,
    equipmentType: 2,
  });
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState<Equipment>();
  const handleOpenEmailModal = (search: SearchResult) => {
    const man: Manufacturer = {
      name: search.manufacturerName,
      id: search.manufacturerId,
      address: null,
      city: null,
      stateId: null,
      zip: null,
      phone: null,
      email: null,
      description: null,
      website: null,
      rimssId: null,
      rimssOemvendorNumber: null,
      rimssPricebookId: null,
      active: null,
      parentManufacturerId: null,
      primaryImageURL: undefined,
      files: null,
      state: null
    };
    const eq: Equipment = {
      id: search.equipmentId,
      number: search.equipmentName,
      manufacturer: man,
      manufacturerId: null,
      rimssId: null,
      price: null,
      cost: null,
      productId: null,
      productSource: null,
      locationId: null,
      oemvendor: null,
      oemdivision: null,
      priceBook: null,
      description: null,
      fullDescription: null,
      upc: null,
      sku: null,
      primaryBin: null,
      quantityOnHand: null,
      quantityCommitted: null,
      quantityOnOrder: null,
      quantityCommittedOnOrder: null,
      averageCost: null,
      manufacturerList: null,
      replacementCost: null,
      productClass: null,
      productCategory: null,
      productGroup: null,
      packageMultiple: null,
      height: null,
      width: null,
      depth: null,
      weight: null,
      associationType: null,
      tradePrice: null,
      listPrice: null,
      special1Price: null,
      special2Price: null,
      special3Price: null,
      inactive: null,
      pricingUoM: null,
      primaryImageURL: undefined,
      categoriesString: null,
      equipmentFeatures: null,
      equipmentSubCategories: null,
      files: null,
      equipmentVideos: null
    };
    setSelectedEquipment(eq);
    setShowEmailModal(true);
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      searchText: localStorage.getItem('searchPartsTextState') ?? '',
      skip: 0,
      reset: true,
    }));
    setHasMore(true);
    getSearchResults();
  }, []);

  const [selectedManufacturerOptions, setSelectedManufacturerOptions] =
    useState<SelectOption[] | null>(
      localStorage.getItem('manufacturersState')
        ? (JSON.parse(
            localStorage.getItem('manufacturersState')!
          ) as SelectOption[])
        : null
    );

  const [selectedCategoryOptions, setSelectedCategoryOptions] = useState<
    SelectOption[] | null
  >(
    localStorage.getItem('categoriesState')
      ? (JSON.parse(localStorage.getItem('categoriesState')!) as SelectOption[])
      : null
  );

  const [selectedSubCategoryOptions, setSelectedSubCategoryOptions] = useState<
    SelectOption[] | null
  >(
    localStorage.getItem('subCategoriesState')
      ? (JSON.parse(
          localStorage.getItem('subCategoriesState')!
        ) as SelectOption[])
      : null
  );

  const manufacturerList = useMemo(() => {
    const list = manufacturers
      .filter((item) => item.rimssOemvendorNumber?.startsWith('2'))
      .map((t) => ({
        label: t.name,
        value: t.id!,
      })) as SelectOption[];

    return [...list];
  }, [manufacturers]);

  const categoryList = useMemo(() => {
    const list = categories.map((t) => ({
      label: t.name,
      value: t.number!,
    })) as SelectOption[];
    return [...list];
  }, [categories]);

  const subCategoryList = useMemo(() => {
    const unique = subCategories.filter((value, index, self) => {
      return self.findIndex((v) => v.name === value.name) === index;
    });
    const list = unique.map((t) => ({
      label: t.name,
      value: t.number!,
    })) as SelectOption[];
    return [...list];
  }, [subCategories]);

  const [minValue, setMinSliderValue] = useState<number>(
    equipmentSearchData?.minPrice ? Math.ceil(equipmentSearchData?.minPrice) : 0
  );
  const [maxValue, setMaxSliderValue] = useState<number>(
    equipmentSearchData?.maxPrice
      ? Math.ceil(equipmentSearchData?.maxPrice)
      : 1000
  );

  // const [skip, setSkip] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const getSearchResults = async () => {
    setIsLoading(true);
    if (selectedManufacturerOptions) {
      formData.manufacturers = selectedManufacturerOptions.map(function (item) {
        return item.label!;
      });
      localStorage.setItem(
        'manufacturersState',
        JSON.stringify(selectedManufacturerOptions)
      );
    } else {
      formData.manufacturers = null;
    }
    if (selectedCategoryOptions) {
      formData.categories = selectedCategoryOptions.map(function (item) {
        return item.label!;
      });
      localStorage.setItem(
        'categoriesState',
        JSON.stringify(selectedCategoryOptions)
      );
    } else {
      formData.categories = null;
    }
    if (selectedSubCategoryOptions) {
      formData.subCategories = selectedSubCategoryOptions.map(function (item) {
        return item.label!;
      });
      localStorage.setItem(
        'subCategoriesState',
        JSON.stringify(selectedSubCategoryOptions)
      );
    } else {
      formData.subCategories = null;
    }
    localStorage.setItem('searchPartsTextState', formData.searchText!);
    // formData.searchText = localStorage.getItem('searchPartsTextState') ?? '';
    SearchApi.search(formData)
      .then((res) => {
        if (res.data.length > 0 || formData.reset) {
          if (formData.reset) {
            setSearchData(res.data);
          } else {
            setSearchData(searchData.concat(res.data));
          }
          setFormData((prevData) => ({
            ...prevData,
            skip: (prevData.skip ?? 0) + 30,
            reset: false,
          }));
        } else {
          setHasMore(false);
        }
        // setSearchData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  // useEffect(() => {
  //   if (searchData.length === 0) {
  //     getSearchResults();
  //   }
  // }, [searchData]);

  useEffect(() => {
    formData.searchText = localStorage.getItem('searchPartsTextState');
    formData.skip = 0;
    formData.reset = true;
    setHasMore(true);
    if ((formData.searchText ?? '').length > 0) getSearchResults();
  }, [localStorage.getItem('searchPartsTextState')]);

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      formData.skip = 0;
      formData.reset = true;
      setHasMore(true);
      getSearchResults();
      handleClose();
      return;
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleClearFiltersClick = () => {
    localStorage.setItem('manufacturersState', '');
    localStorage.setItem('categoriesState', '');
    localStorage.setItem('subCategoriesState', '');
    localStorage.setItem('searchPartsTextState', '');
    localStorage.setItem('minPriceState', '');
    localStorage.setItem('maxPriceState', '');
    setFormData((prevData) => ({
      ...prevData,
      searchText: '',
      manufacturers: null,
      categories: null,
      subCategories: null,
      minPrice: equipmentSearchData?.minPrice
        ? Math.ceil(equipmentSearchData?.minPrice)
        : 0,
      maxPrice: equipmentSearchData?.maxPrice
        ? Math.ceil(equipmentSearchData?.maxPrice)
        : 0,
      equipmentType: 2,
    }));
    setSelectedManufacturerOptions(null);
    setSelectedCategoryOptions(null);
    setSelectedSubCategoryOptions(null);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedFormData = { ...prevData, [name]: Number(value) };

      return updatedFormData;
    });
    setTimeout(() => {
      getSearchResults();
    }, 100); // Small delay ensures state is updated first
  };

  const handleAddItemClick = async (equipment: SearchResult) => {
    if (userModel) {
      let openOrderId =
        localStorage.getItem('openOrderId') &&
        Number(localStorage.getItem('openOrderId')) >= 0
          ? Number(localStorage.getItem('openOrderId'))
          : 0;
      if (openOrderId === 0) {
        await OrderApi.checkUserOpenOrder(userModel.id)
          .then((res) => {
            if (res.data) {
              openOrderId = res.data.id;
              localStorage.setItem('openOrderId', openOrderId.toString());
            } else {
              const newOrder: Order = {
                id: 0,
                businessName: null,
                contactName: null,
                contactPhone: null,
                contactEmail: null,
                notes: null,
                dateCreated: null,
                orderStatusId: 1,
                userId: userModel.id,
                billingAddressId: null,
                shippingAddressId: null,
                dateSubmitted: null,
                ponumber: null,
                clientId: userModel.clientId,
                shippingMethodId: 15,

                client: null,
                orderItems: [],
                billingAddress: null,
                shippingAddress: null,
                user: null,
              };
              OrderApi.addUpdateOrder(newOrder)
                .then((res) => {
                  if (res.data.success) {
                    openOrderId = Number(res.data.affectedEntityIdentifier);
                    localStorage.setItem('openOrderId', openOrderId.toString());
                  }
                })
                .catch((err) => {
                  setIsLoading(false);
                });
            }
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
      const newOrderItem: OrderItem = {
        id: 0,
        orderId: openOrderId,
        equipmentId: equipment.equipmentId,
        quantity: 1,
        equipment: null,
      };
      await OrderApi.addUpdateOrderItem(newOrderItem)
        .then((res) => {
          if (res.data.success) {
            toast.success('Item added to cart');
          }
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
      await OrderApi.getOrderItemsCount(openOrderId)
        .then((res) => {
          if (res.data !== null) {
            localStorage.setItem('orderItemsCount', res.data.toString());
            window.dispatchEvent(new Event('updateOrderItemCount'));
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div className='w-full pt-4'>
      <div className=' mx-auto p-2'>
        <div className='flex mb-2 border-b-2'>
          <h1 className='text-gray-900 font-bold text-4xl pr-10'>
            {location.pathname.includes('parts') ? 'Parts ' : 'Wholegoods '}
            Search
          </h1>
          <Button
            className='buttonMain block lg:hidden'
            onClick={() => setIsOpen(true)}
          >
            Show Filters (
            {(formData.manufacturers?.length ?? 0) +
              (formData.categories?.length ?? 0) +
              (formData.subCategories?.length ?? 0) +
              (formData.searchText && formData.searchText.length > 0 ? 1 : 0)}
            )
          </Button>
          <EmailModal
            isOpen={showEmailModal}
            onClose={() => setShowEmailModal(false)}
            equipment={selectedEquipment!}
            onSendSuccess={() => alert('Email sent!')}
          />
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='flex'>
            <div className='hidden lg:block'>
              <form
                onSubmit={onSubmit}
                className='w-[250px] h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto'
              >
                <div className='pb-5 flex flex-col gap-3'>
                  <Button type='submit' className='buttonMain w-full'>
                    Search
                  </Button>
                  <button
                    type='button'
                    onClick={handleClearFiltersClick}
                    className='buttonCancel w-full'
                  >
                    Clear Filters
                  </button>
                </div>
                <div>
                  <Accordion>
                    <Accordion.Panel>
                      <Accordion.Title className='p-2'>Search</Accordion.Title>
                      <Accordion.Content className='p-2'>
                        <TextInput
                          id='searchText'
                          name='searchText'
                          type='text'
                          placeholder='Search...'
                          onChange={handleChange}
                          value={formData.searchText ?? ''}
                        />
                      </Accordion.Content>
                    </Accordion.Panel>
                  </Accordion>
                </div>
                <div className=''>
                  <Accordion>
                    <Accordion.Panel>
                      <Accordion.Title className='p-2'>
                        Manufacturer
                      </Accordion.Title>
                      <Accordion.Content className='p-2'>
                        <Select
                          className='z-30'
                          options={manufacturerList}
                          value={selectedManufacturerOptions}
                          isMulti
                          onChange={(e) => {
                            if (e) {
                              setSelectedManufacturerOptions(
                                e.map((object) => object)
                              );
                            } else {
                              setSelectedManufacturerOptions(null);
                            }
                          }}
                        />
                      </Accordion.Content>
                    </Accordion.Panel>
                  </Accordion>
                </div>
                <div className=''>
                  <Accordion>
                    <Accordion.Panel>
                      <Accordion.Title className='p-2'>
                        Category
                      </Accordion.Title>
                      <Accordion.Content className='p-2'>
                        <Select
                          className='z-20'
                          options={categoryList}
                          value={selectedCategoryOptions}
                          isMulti
                          onChange={(e) => {
                            if (e) {
                              setSelectedCategoryOptions(
                                e.map((object) => object)
                              );
                            } else {
                              setSelectedCategoryOptions(null);
                            }
                          }}
                        />
                      </Accordion.Content>
                    </Accordion.Panel>
                  </Accordion>
                </div>
                <div className=''>
                  <Accordion>
                    <Accordion.Panel>
                      <Accordion.Title className='p-2'>
                        Sub Category
                      </Accordion.Title>
                      <Accordion.Content className='p-2'>
                        <Select
                          className='z-10'
                          options={subCategoryList}
                          value={selectedSubCategoryOptions}
                          isMulti
                          onChange={(e) => {
                            if (e) {
                              setSelectedSubCategoryOptions(
                                e.map((object) => object)
                              );
                            } else {
                              setSelectedSubCategoryOptions(null);
                            }
                          }}
                        />
                      </Accordion.Content>
                    </Accordion.Panel>
                  </Accordion>
                </div>
                {equipmentSearchData && (
                  <div className=''>
                    <Accordion collapseAll>
                      <Accordion.Panel>
                        <Accordion.Title className='p-2'>Price</Accordion.Title>
                        <Accordion.Content className='p-2'>
                          <div className='flex justify-between'>
                            <div className='flex'>
                              <div>${formData.minPrice}</div>
                            </div>
                            <div className='flex'>
                              <div>${formData.maxPrice}</div>
                            </div>
                          </div>
                          <MultiRangeSlider
                            baseClassName='multi-range-slider-custom'
                            barInnerColor='yellow'
                            ruler={false}
                            label={false}
                            min={minValue}
                            max={maxValue}
                            minValue={formData.minPrice ?? 0}
                            maxValue={formData.maxPrice ?? 1000}
                            onInput={(e: ChangeResult) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                minPrice: e.minValue,
                              }));
                              setFormData((prevData) => ({
                                ...prevData,
                                maxPrice: e.maxValue,
                              }));
                            }}
                          />
                        </Accordion.Content>
                      </Accordion.Panel>
                    </Accordion>
                  </div>
                )}
              </form>
            </div>
            <div className='w-full'>
              {searchData.length === 0 && (
                <div className='w-full text-center justify-items-center text-lg p-5'>
                  <div className='p-3'>Use the search to find products...</div>
                </div>
              )}
              <div
                id='scrollableDiv'
                className='h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto w-full'
              >
                <InfiniteScroll
                  dataLength={searchData.length}
                  next={getSearchResults}
                  hasMore={hasMore}
                  loader={''}
                  scrollableTarget='scrollableDiv'
                >
                  <div className='flex flex-wrap gap-10 justify-center'>
                    {searchData.map((data) => (
                      <div
                        key={data.equipmentId}
                        className='w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6'
                      >
                        <Link to={`/products/equipment/${data.equipmentId}`}>
                          <img
                            className='h-56 sm:h-64 xl:h-64 2xl:h-64 object-contain m-auto'
                            alt={data.equipmentName! + 'Logo'}
                            src={
                              data.imageURL
                                ? data.imageURL
                                : data.manufacturerImageURL
                                ? data.manufacturerImageURL
                                : blankImage
                            }
                          />
                          <div>
                            <h5 className='text-xl font-bold tracking-tight text-gray-900 text-center'>
                              {data.equipmentName!}
                            </h5>
                            {data.description && (
                              <h5 className='text-md font-bold tracking-tight text-gray-900 text-center'>
                                {data.description}
                              </h5>
                            )}
                            <h5 className='text-sm tracking-tight text-gray-900 text-center'>
                              {data.manufacturerName!}
                            </h5>
                            {data.categoryName && (
                              <h5 className='text-sm font-normal tracking-tight text-gray-900 text-center'>
                                {data.categoryName}
                              </h5>
                            )}
                            {data.subCategoryName && (
                              <h5 className='text-sm font-normal tracking-tight text-gray-900 text-center'>
                                {data.subCategoryName}
                              </h5>
                            )}
                          </div>
                          {(data.price ?? 0) > 0 && (
                            <div className='text-xl font-bold tracking-tight text-gray-900 text-center'>
                              ${formatNumbers(data.listPrice ?? 0)}
                            </div>
                          )}
                        </Link>
                        {data && (data.price ?? 0) > 0 && userModel && (
                          <div className='flex justify-center'>
                            <Button
                              type='button'
                              onClick={() => handleAddItemClick(data)}
                              className='buttonMain'
                            >
                              Add to Cart
                            </Button>
                          </div>
                        )}
                        {data && (data.price ?? 0) > 0 && userModel && (
                          <div className='flex justify-center'>
                            <Button
                              type='button'
                              onClick={() =>
                                handleOpenEmailModal(data)
                              }
                              className='buttonMain'
                            >
                              Check Availability
                            </Button>
                          </div>
                        )}
                        {data && (data.price ?? 0) > 0 && !userModel && (
                          <div className='flex justify-center'>
                            <Link to={'/login'}>
                              <Button
                                type='button'
                                // onClick={() => handleAddItemClick(equipmentData)}
                                className='buttonMain'
                              >
                                Login to order
                              </Button>
                            </Link>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='block lg:hidden'>
        <Drawer open={isOpen} onClose={handleClose} className=''>
          <Drawer.Header title='Filters' titleIcon={FaFilter} />
          <Drawer.Items>
            <form onSubmit={onSubmit}>
              <div className='pb-5 flex flex-col gap-3'>
                <Button type='submit' className='buttonMain w-full'>
                  Search
                </Button>
                <button
                  type='button'
                  onClick={handleClearFiltersClick}
                  className='buttonCancel w-full'
                >
                  Clear Filters
                </button>
              </div>
              <div>
                <Accordion>
                  <Accordion.Panel>
                    <Accordion.Title className='p-2'>Search</Accordion.Title>
                    <Accordion.Content className='p-2'>
                      <TextInput
                        id='searchText'
                        name='searchText'
                        type='text'
                        placeholder='Search...'
                        onChange={handleChange}
                        value={formData.searchText ?? ''}
                      />
                    </Accordion.Content>
                  </Accordion.Panel>
                </Accordion>
              </div>
              <div className=''>
                <Accordion>
                  <Accordion.Panel>
                    <Accordion.Title className='p-2'>
                      Manufacturer
                    </Accordion.Title>
                    <Accordion.Content className='p-2'>
                      <Select
                        className='z-30'
                        options={manufacturerList}
                        value={selectedManufacturerOptions}
                        isMulti
                        onChange={(e) => {
                          if (e) {
                            setSelectedManufacturerOptions(
                              e.map((object) => object)
                            );
                          } else {
                            setSelectedManufacturerOptions(null);
                          }
                        }}
                      />
                    </Accordion.Content>
                  </Accordion.Panel>
                </Accordion>
              </div>
              <div className=''>
                <Accordion>
                  <Accordion.Panel>
                    <Accordion.Title className='p-2'>Category</Accordion.Title>
                    <Accordion.Content className='p-2'>
                      <Select
                        className='z-20'
                        options={categoryList}
                        value={selectedCategoryOptions}
                        isMulti
                        onChange={(e) => {
                          if (e) {
                            setSelectedCategoryOptions(
                              e.map((object) => object)
                            );
                          } else {
                            setSelectedCategoryOptions(null);
                          }
                        }}
                      />
                    </Accordion.Content>
                  </Accordion.Panel>
                </Accordion>
              </div>
              <div className=''>
                <Accordion>
                  <Accordion.Panel>
                    <Accordion.Title className='p-2'>
                      Sub Category
                    </Accordion.Title>
                    <Accordion.Content className='p-2'>
                      <Select
                        className='z-10'
                        options={subCategoryList}
                        value={selectedSubCategoryOptions}
                        isMulti
                        onChange={(e) => {
                          if (e) {
                            setSelectedSubCategoryOptions(
                              e.map((object) => object)
                            );
                          } else {
                            setSelectedSubCategoryOptions(null);
                          }
                        }}
                      />
                    </Accordion.Content>
                  </Accordion.Panel>
                </Accordion>
              </div>
              {equipmentSearchData && (
                <div className=''>
                  <Accordion collapseAll>
                    <Accordion.Panel>
                      <Accordion.Title className='p-2'>Price</Accordion.Title>
                      <Accordion.Content className='p-2'>
                        <div className='flex justify-between'>
                          <div className='flex'>
                            <div>${formData.minPrice}</div>
                          </div>
                          <div className='flex'>
                            <div>${formData.maxPrice}</div>
                          </div>
                        </div>
                        <MultiRangeSlider
                          baseClassName='multi-range-slider-custom'
                          barInnerColor='yellow'
                          ruler={false}
                          label={false}
                          min={minValue}
                          max={maxValue}
                          minValue={formData.minPrice ?? 0}
                          maxValue={formData.maxPrice ?? 1000}
                          onInput={(e: ChangeResult) => {
                            setFormData((prevData) => ({
                              ...prevData,
                              minPrice: e.minValue,
                            }));
                            setFormData((prevData) => ({
                              ...prevData,
                              maxPrice: e.maxValue,
                            }));
                          }}
                        />
                      </Accordion.Content>
                    </Accordion.Panel>
                  </Accordion>
                </div>
              )}
            </form>
          </Drawer.Items>
        </Drawer>
      </div>
    </div>
  );
}
